export default {
  "hero.tag": "会員制",
  "hero.referral": "",
  "hero.title1": "「作曲してみたい」から、「自分の音楽をつくれる」に。",
  "hero.subtitle": "プロがあなたに合わせて制作環境をセットアップします。\n才能より、正しいスタートを。",
  "hero.title2": "",
  "hero.description1": "",
  "hero.description2": "",
  "hero.description3": "",
  "hero.bottomText": "",
  "nav.home": "Home",
  "nav.philosophy": "",
  "nav.curriculum": "Learning Environment",
  "nav.instructors": "Instructors",
  "nav.pricing": "Pricing",
  "nav.contact": "Contact",
  "philosophy.label": "",
  "philosophy.title": "",
  "philosophy.description": "",
  "threepillars.label": "Three Pillars",
  "threepillars.title": "最短 “6ヶ月間で仕上げる”\n正しい知識さえ得られれば最短が可能",
  "threepillars.pillar1.title": "最初から、つくれる環境。",
  "threepillars.pillar1.subtitle": "READY TO CREATE",
  "threepillars.pillar1.desc": "セットアップされた制作環境で、\n迷うことなく音楽制作をスタート。",
  "threepillars.pillar2.title": "時間の無駄を削減",
  "threepillars.pillar2.subtitle": "Eliminate Wasted Time",
  "threepillars.pillar2.desc": "必要なものだけを、プロが選ぶ。\n機材もソフトも情報も、\n自分で一つひとつ調べる必要はありません。",
  "threepillars.pillar3.title": "クオリティ向上を最短で",
  "threepillars.pillar3.subtitle": "Rapid Quality Growth",
  "threepillars.pillar3.desc": "大切な人へ曲を贈りませんか。",
  "curriculum.tag": "Learning Environment",
  "curriculum.title": "講師と同じ環境で学ぶから、\n上達が圧倒的に早い。",
  "curriculum.subtitle": "Studio Proを中心に、Cubase・Ableton・Logic Pro・の全DAWにも対応。",
  "curriculum.item1.title": "作曲・編曲",
  "curriculum.item1.description": "深い知見を活かし、\nあなたの音楽を豊かに育てます。\nそして、必ず形になるまで一緒に伴走していきます。",
  "curriculum.item2.title": "DTM / DAW",
  "curriculum.item2.description": "講師と同じ環境で学ぶから、上達が\n圧倒的に早い。\nStudio Proを中心に、Cubase・Ableton・Logic Pro・の全DAWにも対応。",
  "curriculum.item3.title": "Mix",
  "curriculum.item3.description": "現場で通用するミキシング技術。\n音の空間設計から最終仕上げまで、プロ御用達スタジオにて学びます。",
  "curriculum.item4.title": "機材・環境構築",
  "curriculum.item4.description": "必要機材を一括提案・購入サポート。無駄な出費を削ぎ、すぐに制作を始められます。",
  "curriculum.schedule.title": "学習スケジュール",
  "curriculum.schedule.phaseLabel": "Phase",
  "curriculum.schedule.session": "第{n}回",
  "curriculum.schedule.p1s1": "機材導入・環境設定",
  "curriculum.schedule.p1s2": "基礎構築①",
  "curriculum.schedule.p1s3": "基礎構築②",
  "curriculum.schedule.p1s4": "確認",
  "curriculum.schedule.p2s1": "実践制作①",
  "curriculum.schedule.p2s2": "実践制作②",
  "curriculum.schedule.p2s3": "実践制作③",
  "curriculum.schedule.p2s4": "確認",
  "curriculum.schedule.p3s1": "実践制作①",
  "curriculum.schedule.p3s2": "実践制作②",
  "curriculum.schedule.p3s3": "実践制作③",
  "curriculum.schedule.p3s4": "確認",
  "curriculum.schedule.p4s1": "実践制作①",
  "curriculum.schedule.p4s2": "実践制作②",
  "curriculum.schedule.p4s3": "実践制作③",
  "curriculum.schedule.p4s4": "確認",
  "curriculum.schedule.p5s1": "実践制作①",
  "curriculum.schedule.p5s2": "実践制作②",
  "curriculum.schedule.p5s3": "実践制作③",
  "curriculum.schedule.p5s4": "確認",
  "curriculum.schedule.p6s1": "実践制作①",
  "curriculum.schedule.p6s2": "実践制作②",
  "curriculum.schedule.p6s3": "最終仕上げ①",
  "curriculum.schedule.p6s4": "最終仕上げ②",
  "instructors.label": "Instructors",
  "instructors.title1": "世界が認める 現役のプロ",
  "instructors.title2": "",
  "foundersMessage.label": "Message",
  "foundersMessage.title": "このコンサルティングを始めた理由",
  "foundersMessage.p1": "ありがたいことに、これまでSNSなどを通じて「現役で活動している人から直接学びたい」「本気でプロを目指したいので教えてほしい」といったご連絡を数多くいただいておりました。",
  "foundersMessage.p2": "しかし、本業での制作を優先していたこともあり、そのすべてにお応えすることができず、ずっと心苦しく感じていました。",
  "foundersMessage.p3": "一方で、私はもし教えるのであれば、「ただ曲が作れるようになる」ことをゴールにするのではなく、プロの現場でも通用するクオリティや考え方までしっかり身につけていただきたいという想いがありました。",
  "foundersMessage.p4": "そうした想いに加え、多くの方から継続的にご要望をいただいていたこともあり、このコンサルティングをスタートすることを決意しました。",
  "foundersMessage.p5": "本気でプロを目指す方や、コンペ・商業レベルで通用する実力を身につけたい方に向けて、現場で培ってきた知識や経験を実践的にお伝えしていきます。",
  "testimonials.title": "受講生の声",
  "testimonials.quote": "「完全にオーダーメイドのレッスンで、自分のペースで深く学べる。これまでの習い事とは次元が違う体験です。」",
  "testimonials.author": "K.T. — 経営者",

  "pricing.hero.tag": "",
  "pricing.hero.brand1": "",
  "pricing.hero.brand2": "Zero",
  "pricing.hero.brand3": "to",
  "pricing.hero.brand4": "One",
  "pricing.hero.desc": "",
  "pricing.hero.description": "音楽を始めたい人のために、プロが「必要なものだけ」を選び、\n最初から最高の制作環境を整えます。才能より、正しいスタートを。",
  "pricing.hero.descriptionMobile": "音楽を始めたい人のために、\nプロが「必要なものだけ」を選び、\n最初から最高の制作環境を整えます。\n才能より、正しいスタートを。",
  "pricing.hero.membership": "会員制",
  "pricing.hero.programLabel": "MAISON SOUNDでは、\n「調べる」→「選ぶ」→「買う」→「設定する」→「学ぶ」\nという面倒なプロセスを全部飛ばして、\n最初から、音楽をつくることに集中します。\n\n音楽の知識がなくても、\n何から始めればいいかわからなくても、\n最初の一歩はすべてお任せください。\nその選択を担うのは、音楽を知り尽くしたプロフェッショナルです。",
  "pricing.hero.programLabelMobile": "MAISON SOUNDでは、\n「調べる」→「選ぶ」→「買う」→\n「設定する」→「学ぶ」\nという面倒なプロセスを全部飛ばして、\n最初から、音楽をつくることに集中します。\n\n音楽の知識がなくても、\n何から始めればいいかわからなくても、\n最初の一歩はすべてお任せください。\nその選択を担うのは、音楽を知り尽くした\nプロフェッショナルです。",

  "pricing.plans.tag": "Service",
  "pricing.plans.title": "作曲コンサルティング",
  "pricing.plans.subtitle": "",

  "pricing.plan1.name": "対面コンサルティング",
  "pricing.plan1.recommended": "おすすめ",
  "pricing.plan1.tag": "FULL SUPPORT",
  "pricing.plan1.price": "¥1,430,000",
  "pricing.plan1.per": "/6ヶ月間",
  "pricing.plan1.duration": "",
  "pricing.plan1.enrollment": "入会金 ¥110,000を含みます。",
  "pricing.plan1.desc": "プロ御用達のスタジオを貸切。贅沢な音響環境で、リアルタイムのフィードバックを受けながら、最短でスキルを身につけます。",
  "pricing.plan1.f1": "月4回 1対1マンツーマン",
  "pricing.plan1.f2": "*6ヶ月でプロ作曲クオリティを目標",
  "pricing.plan1.f3": "機材・ソフト選定サポート",
  "pricing.plan1.f4": "プロ御用達スタジオにて対面指導",
  "pricing.plan1.f5": "作曲・アレンジ全対応",
  "pricing.plan1.cta": "ご入会のご相談",

  "pricing.plan2.name": "オンラインコンサルティング",
  "pricing.plan2.tag": "FULL SUPPORT",
  "pricing.plan2.price": "¥1,430,000",
  "pricing.plan2.per": "/6ヶ月間",
  "pricing.plan2.duration": "",
  "pricing.plan2.enrollment": "入会金 ¥110,000を含みます。",
  "pricing.plan2.desc": "ご自宅から、講師と同じ画面を見ながら受講。画面共有で細かな操作もリアルタイムに指導。出張が多い方や遠方の方にも最適です。",
  "pricing.plan2.f_common1": "月4回 1対1マンツーマン",
  "pricing.plan2.f_common2": "月4回のレッスンに加え、ご希望に応じて別日に個別サポートを実施",
  "pricing.plan2.f2": "Zoom / Google Meet対応",
  "pricing.plan2.f3": "画面共有で細かい指導",
  "pricing.plan2.f4": "作曲・アレンジ全対応",
  "pricing.plan2.f5": "機材・ソフト選定サポート",
  "pricing.plan2.f6": "*6ヶ月でプロ作曲クオリティを目標",
  "pricing.plan2.cta": "ご入会のご相談",

  "pricing.equipment.tag": "Equipment Support",
  "pricing.equipment.title": "機材サポート",
  "pricing.equipment.catchphrase": "\"ありそうでなかった\"を形にしました。",
  "pricing.equipment.subtitle": "PC・DAW・音源・サブスクの一括提案。\n“本当に必要なもの”だけを厳選。",
  "pricing.equipment.subtitleMobile": "PC・DAW・音源・サブスクの一括提案。\n“本当に必要なもの”だけを\n厳選。",
  "pricing.equipment.listTitle": "1からスタートの場合、必須なもの",
  "pricing.equipment.item1Name": "WAVES Horizon",
  "pricing.equipment.item1Price": "¥40,700",
  "pricing.equipment.item2Name": "DAW（Studio One推奨）\n※Cubase, Logic, Ableton対応可",
  "pricing.equipment.item2Price": "¥20,800",
  "pricing.equipment.item3Name": "Logicoolトラックボールマウス",
  "pricing.equipment.item3Price": "¥17,800",
  "pricing.equipment.item4Name": "オーディオインターフェイス、ケーブル",
  "pricing.equipment.item4Price": "¥40,700",
  "pricing.equipment.item5Name": "マイク（ケーブル、スタンド、ポップガード込み）",
  "pricing.equipment.item5Price": "¥30,700",
  "pricing.equipment.item6Name": "MIDIキーボード",
  "pricing.equipment.item6Price": "—",
  "pricing.equipment.item7Name": "Splice",
  "pricing.equipment.item7Price": "$12.99",
  "pricing.equipment.item8Name": "PC",
  "pricing.equipment.item8Price": "",
  "pricing.equipment.item1": "WAVES Horizon ¥40,700",
  "pricing.equipment.item2": "DAW（Studio One推奨）¥20,800\n※Cubase, Logic, Ableton対応可",
  "pricing.equipment.item3": "Logicoolトラックボールマウス ¥17,800",
  "pricing.equipment.item4": "オーディオインターフェイス、ケーブル ¥40,700",
  "pricing.equipment.item5": "マイク（マイクケーブル、マイクスタンド、ポップガード込み）¥30,700",
  "pricing.equipment.item6": "MIDIキーボード",
  "pricing.equipment.item7": "Splice $12.99",
  "pricing.equipment.badge": "KEY FEATURE",
  "pricing.equipment.flowLabel": "導入の流れ",
  "pricing.equipment.step1": "必要機材を一括提案",
  "pricing.equipment.step2": "最適な機材を選定・購入",
  "pricing.equipment.step3": "購入当日に環境構築・セットアップ",
  "pricing.equipment.step4": "即日から制作スタート",
  "pricing.equipment.cta": "ご入会のご相談",
  "pricing.equipment.note2": "無駄な出費なし、すぐ制作スタート",
  "pricing.equipment.note3": "費用は都度ご提示・ご相談。購入前に必ず詳細をご案内します",
  "pricing.equipment.essentialsTitle": "０からスタートの場合",
  "pricing.equipment.essentialsSub": "受講開始時に必須な機材・プラグイン一覧",
  "pricing.equipment.essentialsNote": "初月に必須プラグイン料金も併せてかかります。\n価格は時期によって変動します。",
  "pricing.equipment.instructorNote": "※すべての機材は講師が一括で購入・手配します。会員の方は手間なく、すぐに制作を開始できます。",
  "pricing.equipment.extraCost": "※機材サポートをご希望の場合は、別途機材費が発生します。",

  "pricing.followup.title": "1ターム（6ヶ月）終了後のフォローアップ体制",
  "pricing.followup.plan": "全6回",
  "pricing.followup.price": "¥330,000",
  "pricing.followup.periodNote": "＊6ヶ月期限",
  "pricing.followup.note": "",
  "pricing.followup.b1": "モチベーションの維持",
  "pricing.followup.b2": "クオリティの維持",
  "pricing.followup.b3": "他ジャンルの知識習得",
  "pricing.followup.b4": "新トレンド技術の学習",
  "pricing.followup.f1": "月4回 1対1マンツーマン",
  "pricing.followup.f2": "月4回のレッスンに加え、ご希望に応じて別日に個別サポートを実施",

  "pricing.plan1.f_support": "月4回のレッスンに加え、ご希望に応じて別日に個別サポートを実施",
  "pricing.plan1.noteReview": "*毎月末審査あり、課題を必ず行うこと前提としています",
  "pricing.plan1.noteInquiry": "詳細はお問い合わせください",

  "pricing.steps.tag": "Learning Steps",
  "pricing.steps.title": "学習のステップ",
  "pricing.steps.subtitle": "",
  "pricing.steps.note": "会員様お一人おひとりのご経験や目標に合わせ、最適な設計プランをご提案いたします。\nお問い合わせの際に、現在の制作状況や目指す方向性をお知らせください。",
  "pricing.steps.noteMobile": "会員様お一人おひとりのご経験や目標に合わせ、\n最適な設計プランをご提案いたします。\nお問い合わせの際に、現在の制作状況や目指す方向性を\nお知らせください。",
  "pricing.step1.label": "FOUNDATION",
  "pricing.step1.month": "Month 01",
  "pricing.step1.title": "環境構築 & 初めての一曲",
  "pricing.step1.desc": "プラグインの全セットアップを完了。DAWの基本操作からMIDI打ち込み、簡単なコード進行まで。最初のステップの終わりには、自分の手で初めての楽曲を形にします。",
  "pricing.step2.label": "DEVELOPMENT",
  "pricing.step2.month": "Month 02",
  "pricing.step2.title": "アレンジ & 音作り",
  "pricing.step2.desc": "ソフト音源の選び方、ドラム・ベースの打ち込み、エフェクトの基礎を学びます。次のステップでは、さらに厚みのあるサウンドを目指します。",
  "pricing.step3.label": "COMPLETION",
  "pricing.step3.month": "Month 03",
  "pricing.step3.title": "ミックス & マスタリング",
  "pricing.step3.desc": "EQ、コンプレッサー、リバーブを使いこなし、プロ級の音質に仕上げるテクニックを習得。最終ステップでオリジナル曲を完成させます。",

  "pricing.step4.label": "REPETITION",
  "pricing.step4.month": "Month 04",
  "pricing.step4.title": "反復制作①",
  "pricing.step4.desc": "身につけた技術を繰り返し実践。体が覚えるまで、様々なジャンルの楽曲制作に取り組み、講師のフィードバックで表現の幅を広げます。",

  "pricing.step5.label": "REPETITION",
  "pricing.step5.month": "Month 05",
  "pricing.step5.title": "反復制作②",
  "pricing.step5.desc": "さらに複雑なアレンジに挑戦。繰り返し制作することで、プロのワークフローが自然と身につきます。自分の「得意」が見えてくる時期です。",

  "pricing.step6.label": "FINAL",
  "pricing.step6.month": "Month 06",
  "pricing.step6.title": "最終仕上げ",
  "pricing.step6.desc": "6ヶ月間の集大成。繰り返し磨いてきた技術で、プロクオリティのデモ音源を完成させます。ここからが本当のスタートです。",

  "pricing.limit.note": "各タームの受講枠は最大4名限定",

  "pricing.cta.tag": "First Step",
  "pricing.cta.title": "一歩を踏み出す",
  "pricing.cta.desc": "6ヶ月間のマンツーマンコンサルティング。\nゼロからの方もプロ作家クオリティへ。まずはご入会のご相談から。",
  "pricing.cta.button1": "ご入会のご相談",
  "pricing.cta.button2": "",

  "cta.title": "特別な創作体験を、あなたに。",
  "cta.description": "一人ひとりに十分な時間とサポートを提供するため、各タームの受講枠は4名限定です。\n\n6か月間を1タームとして運営しており、募集枠が埋まった場合、次回のご案内は原則として6か月後となります。\n\n定員に達し次第、受付を終了いたしますので、ご興味のある方はお早めにご相談ください。\n\nなお、空席が生じた場合は、予約待ちの方を優先してご案内いたします。",
  "cta.button": "ご入会のご相談",
  "footer.logo": "Maison Sound",
  "footer.description": "現役プロ作家による完全個別のコンサルティング",
  "footer.column1.title": "About",
  "footer.column1.link1": "Instructors",
  "footer.column1.link2": "Learning Environment",
  "footer.column1.link3": "",
  "footer.column1.link4": "",
  "footer.column2.title": "Contact",
  "footer.column2.link1": "お問い合わせ",
  "footer.column2.link2": "",
  "footer.column2.link3": "Pricing",
  "footer.column2.link4": "FAQ",
  "footer.column3.title": "Legal",
  "footer.column3.link1": "プライバシーポリシー",
  "footer.column3.link2": "利用規約",
  "footer.copyright": "© 2025 Maison Sound. All rights reserved.",
  "footer.newsletter.placeholder": "メールアドレス",
  "footer.newsletter.button": "お問い合わせ",

  "inquiry.hero.tag": "Contact",
  "inquiry.hero.title": "お問い合わせ",
  "inquiry.hero.subtitle": "特別な音楽創作への第一歩。まずはお気軽にご連絡ください。",

  "inquiry.form.name": "お名前",
  "inquiry.form.email": "メールアドレス",
  "inquiry.form.phone": "電話番号",
  "inquiry.form.format": "希望レッスン形式",
  "inquiry.format.inPerson": "対面レッスン",
  "inquiry.format.online": "オンラインレッスン",
  "inquiry.form.interest": "興味のある分野",
  "inquiry.interest.composition": "作曲・編曲",
  "inquiry.interest.dtm": "DTM・DAW",
  "inquiry.interest.mix": "Mix・マスタリング",
  "inquiry.interest.equipment": "機材・環境構築",
  "inquiry.form.level": "現在の音楽経験",
  "inquiry.level.beginner": "初心者（1から始める）",
  "inquiry.level.intermediate": "経験あり（独学で触ったことがある）",
  "inquiry.level.advanced": "上級（既に作品を持っている）",
  "inquiry.form.message": "ご質問・ご要望",
  "inquiry.form.submit": "送信する",
  "inquiry.form.privacy": "ご入力いただいた情報は、お問い合わせ対応のみに使用いたします。",
  "inquiry.form.emailLabel": "ご入会のご相談",
  "inquiry.form.emailDescription": "お問い合わせの際は、以下の内容もあわせてご記載いただけますと、スムーズにご案内できます。\n\n・ご使用中のDAW\n・DAWのご経験（使用歴）\n・デモ作品（お持ちの場合）\n・今後6か月間で達成したい目標",
  "inquiry.form.responseTime": "※ 1〜2営業日以内にご返信いたします",

  "privacy.hero.label": "Legal",
  "privacy.hero.title": "プライバシーポリシー",
  "privacy.lastUpdated": "最終更新日: 2025年6月",
  "privacy.section1.title": "1. 個人情報の収集について",
  "privacy.section1.p1": "当教室（以下「当方」）は、お問い合わせ・ご入会の際に、お名前、メールアドレス、電話番号、その他ご相談内容に必要な情報を収集することがあります。",
  "privacy.section1.p2": "これらの情報は、お客様からのご依頼・ご相談に対応するためにのみ使用されます。",
  "privacy.section2.title": "2. 個人情報の利用目的",
  "privacy.section2.p1": "収集した個人情報は、以下の目的で利用します。",
  "privacy.section2.li1": "レッスン・コンサルティングの提供および運営",
  "privacy.section2.li2": "お問い合わせへの対応",
  "privacy.section2.li3": "サービスの改善および新サービス開発の参考",
  "privacy.section2.li4": "重要なお知らせや契約内容変更のご連絡",
  "privacy.section3.title": "3. 個人情報の第三者提供",
  "privacy.section3.p1": "当方は、以下のいずれかに該当する場合を除き、お客様の個人情報を第三者に提供することはありません。",
  "privacy.section3.li1": "お客様ご本人の同意がある場合",
  "privacy.section3.li2": "法令に基づく場合",
  "privacy.section3.li3": "人の生命、身体または財産の保護のために必要な場合",
  "privacy.section3.li4": "公衆衛生の向上または児童の健全な育成推進のために特に必要な場合",
  "privacy.section4.title": "4. 個人情報の管理",
  "privacy.section4.p1": "当方は、収集した個人情報を適切に管理し、漏洩・紛失・改ざん等の防止に努めます。個人情報へのアクセスは必要最小限の者のみに制限し、厳重に保管します。",
  "privacy.section5.title": "5. アクセス解析ツールについて",
  "privacy.section5.p1": "当ウェブサイトでは、サービスの改善を目的として、アクセス解析ツール（Google Analytics等）を使用する場合があります。",
  "privacy.section5.p2": "これらのツールは、Cookieを使用してトラフィックデータを収集しますが、個人を特定する情報は含まれません。",
  "privacy.section6.title": "6. お問い合わせ窓口",
  "privacy.section6.p1": "ご質問・ご相談は以下のお問い合わせフォームよりご連絡ください。",
  "privacy.section6.link": "お問い合わせフォーム",
  "privacy.section7.title": "7. 改定について",
  "privacy.section7.p1": "本ポリシーは、法令の改正やサービス内容の変更に伴い、予告なく改定されることがあります。改定後のポリシーは、本ページに掲載された時点より効力を生じます。",

  "features.tag": "Lesson Features",
  "features.title": "ここでしか味わえない体験",
  "features.equipment.title": "機材選びからサポート",
  "features.equipment.desc": "PC・DAW・音源・サブスク等を一括提案。現役作家が「本当に必要なもの」だけを厳選します。1からスタートの場合でも、無駄な出費ゼロですぐに制作に取り掛かれます。",
  "features.equipment.item1": "WAVES Horizon ¥40,700",
  "features.equipment.item2": "DAW（Studio One推奨）¥20,800",
  "features.equipment.item3": "Logicoolトラックボールマウス ¥17,800",
  "features.equipment.item4": "オーディオインターフェイス、ケーブル ¥40,700",
  "features.equipment.item5": "マイク（ケーブル・スタンド・ポップガード込み）¥30,700",
  "features.equipment.item6": "MIDIキーボード",
  "features.equipment.item7": "Splice $12.99",
  "features.individual.title": "完全個別・少人数制",
  "features.individual.desc": "グループレッスンは一切ありません。月4回、1対1で現役プロ作曲家が直接指導。同じ環境・機材で学ぶから、上達が圧倒的に早い。",
  "features.individual.stat1": "対 1",
  "features.individual.stat2": "回/月",
  "features.individual.stat3": "グループ",
  "features.genre.title": "ジャンル問わず対応",
  "features.genre.desc": "J-POP・DTM・バンドサウンドまで幅広く対応。あなたが創りたい音楽に合わせて、カリキュラムを完全オーダーメイドします。",

  "features.equipment.note": "※費用は都度ご提示・ご相談。購入前に必ず詳細をご案内します。",

  "faq.hero.tag": "FAQ",
  "faq.hero.title": "よくあるご質問",
  "faq.hero.subtitle": "作曲コンサルティングに関する、よくあるご質問にお答えします。",
  "faq.bottomText": "さらに詳しいご質問は、お気軽にお問い合わせください。",
  "faq.q1.question": "完全初心者ですが、レッスンを受けられますか？",
  "faq.q1.answer": "もちろんです。当プログラムは、音楽経験ゼロの方からスタートできるように設計されています。機材の選定・セットアップから丁寧にサポートしますので、初めての方でも安心してご参加いただけます。",
  "faq.q2.question": "レッスンの頻度と時間を教えてください。",
  "faq.q2.answer": "月4回・1回あたり約90分のマンツーマンレッスンが基本です。これに加え、ご希望の方には別日に個別サポートを実施します。対面レッスンの場合はプロ御用達のスタジオを貸切、オンラインの場合はZoomまたはGoogle Meetを使用します。",
  "faq.q3.question": "必要な機材はどのようなものですか？",
  "faq.q3.answer": "PC、DAWソフトウェア（Studio One推奨）、オーディオインターフェイス、ヘッドホンまたはスピーカーが基本となります。どの機材を選べばよいかは、初回カウンセリング時にご提案いたします。また、機材の購入サポートからセットアップまで対応いたします。",
  "faq.q4.question": "レッスンの振替は可能ですか？",
  "faq.q4.answer": "原則として3日前までのご連絡で振替が可能です。急なご予定変更の場合も、可能な限り柔軟に対応いたしますので、まずはご相談ください。",
  "faq.q5.question": "オンラインレッスンでも対面と同等の効果がありますか？",
  "faq.q5.answer": "はい。画面共有機能を使用して、講師と同じ画面を見ながらリアルタイムで指導を行います。細かな操作もその場で確認できるため、遠方の方や出張の多い方にもご好評いただいています。",
  "faq.q6.question": "6ヶ月間のプログラム終了後はどうなりますか？",
  "faq.q6.answer": "プログラム終了後は、ご希望に応じてフォローアップパッケージをご利用いただけます。また、修了後も継続して自走できるよう、自主制作の進め方についてもアドバイスいたします。",
  "faq.q7.question": "特定のジャンルだけを学びたいのですが可能ですか？",
  "faq.q7.answer": "もちろんです。J-POP、DTM、バンドサウンドなど、あなたが創りたい音楽に合わせてカリキュラムを完全オーダーメイドします。特定のアーティストの楽曲を参考に学ぶことも可能です。",
  "faq.q8.question": "支払い方法は何に対応していますか？",
  "faq.q8.answer": "銀行振込およびクレジットカード決済に対応しております。詳細はご入会時のカウンセリングでご案内いたします。",
  "faq.q9.question": "レッスンがない日の課題やサポートはありますか？",
  "faq.q9.answer": "月4回のマンツーマンレッスンに加え、ご希望の方には週2〜3日のZoom指導を設けています。また、毎回のレッスンで課題をお出しするため、自然と毎日なにかしら制作に触れることになります。継続的なインプットとアウトプットのサイクルが、6ヶ月間での飛躍的な成長を支えます。",

  "terms.hero.label": "Legal",
  "terms.hero.title": "利用規約",
  "terms.lastUpdated": "最終更新日: 2025年7月",
  "terms.section1.title": "第1条（適用）",
  "terms.section1.p1": "本規約は、Maison Sound（以下「当サービス」）が提供する作曲コンサルティングサービス（以下「本サービス」）の利用に関する条件を定めるものです。本サービスのご利用をもって、本規約のすべてに同意したものとみなします。",
  "terms.section2.title": "第2条（入会）",
  "terms.section2.p1": "当サービスは完全会員制です。ご入会をご希望の方は、当サービスへの直接のお問い合わせが必要です。",
  "terms.section2.p2": "入会に際しては、所定の入会金（¥110,000）をお支払いいただきます。入会金はプログラム料金に含まれ、返金はいたしかねます。",
  "terms.section2.p3": "各タームの受講枠は最大4名限定です。募集枠が埋まった場合、次回のご案内は原則として6ヶ月後となります。",
  "terms.section3.title": "第3条（サービスの内容）",
  "terms.section3.li1": "月4回・1対1のマンツーマンコンサルティング（1回約90分）",
  "terms.section3.li2": "作曲・編曲・ミキシング・マスタリングの個別指導",
  "terms.section3.li3": "機材・ソフトウェアの選定および環境構築サポート",
  "terms.section3.li4": "ご希望に応じて、レッスン日に加えた個別サポートの実施",
  "terms.section3.li5": "対面レッスン（プロ御用達スタジオ）またはオンラインレッスン（Zoom / Google Meet）",
  "terms.section3.li6": "プログラム期間は6ヶ月間を1タームとします",
  "terms.section4.title": "第4条（料金および支払い）",
  "terms.section4.p1": "本サービスのプログラム料金は、対面コンサルティング・オンラインコンサルティングともに同一料金です。1ターム（6ヶ月間）のプログラム料金には入会金が含まれます。詳細な料金については、お問い合わせの際にご案内いたします。",
  "terms.section4.p2": "お支払い方法は銀行振込またはクレジットカード決済に対応しております。詳細はご入会時のカウンセリングにてご案内いたします。",
  "terms.section4.p3": "機材サポートをご希望の場合は、別途機材費が発生します。費用は都度ご提示・ご相談のうえ、購入前に必ず詳細をご案内いたします。",
  "terms.section4.p4": "",
  "terms.section5.title": "第5条（キャンセル・日程変更）",
  "terms.section5.p1": "レッスン日程の変更は、原則として3日前までのご連絡で対応可能です。",
  "terms.section5.p2": "急なご予定変更の場合も、可能な限り柔軟に対応いたしますので、まずはご相談ください。",
  "terms.section5.p3": "当日の無断キャンセルについては、原則として振替対応をいたしかねます。",
  "terms.section6.title": "第6条（中途解約）",
  "terms.section6.p1": "本プログラムは6ヶ月間を1タームとして設計されており、プログラム期間中の中途解約は原則としてお受けしておりません。",
  "terms.section6.p2": "ただし、やむを得ない事情により中途解約をご希望の場合は、速やかにご相談ください。状況に応じて、当社の判断により個別に対応を検討いたします。",
  "terms.section6.p3": "中途解約が認められた場合は、未受講期間に応じた金額を基準として返金額を算定いたします。なお、入会金は返金対象外とし、返金額から解約事務手数料として10％を控除した金額を返金いたします。",
  "terms.section7.title": "第7条（禁止事項）",
  "terms.section7.li1": "レッスン内容の無断録音・録画・配信・SNS等への投稿",
  "terms.section7.li2": "講師および他受講生への迷惑行為・ハラスメント",
  "terms.section7.li3": "レッスンで使用するスタジオ設備の不適切な利用・破損",
  "terms.section7.li4": "当サービスの信用を毀損する行為",
  "terms.section7.li5": "レッスンで提供する教材・ノウハウの第三者への無断共有・転売",
  "terms.section8.title": "第8条（免責事項）",
  "terms.section8.p1": "当サービスは、受講者の作品の商業的成功や特定の成果を保証するものではありません。本サービスはあくまで技術・知識の提供を目的とします。",
  "terms.section8.p2": "機材の購入・設定に関する提案は、講師の知見に基づく参考情報として提供するものであり、最終的な購入判断は受講者ご自身で行っていただきます。",
  "terms.section8.p3": "天災・停電・通信障害その他不可抗力によりレッスンが実施できなかった場合、当サービスはこれによって生じた損害について責任を負いかねます。振替日程の調整をもって対応といたします。",
  "terms.section9.title": "第9条（個人情報の取り扱い）",
  "terms.section9.p1": "お客様からご提供いただいた個人情報は、本サービスの提供およびご連絡の目的に限り使用し、第三者に提供することはありません。詳細についてはプライバシーポリシーをご参照ください。",
  "terms.section10.title": "第10条（規約の変更）",
  "terms.section10.p1": "当サービスは、必要に応じて本規約を改定することができます。改定後の規約は、本ページに掲載された時点より効力を生じるものとします。重要な変更がある場合は、会員の皆様に事前に通知いたします。",
};